import React from 'react';
import LegalLayout from './LegalLayout';
import './legal.css';

const CancellationRefund = () => (
  <LegalLayout title="Cancellation & Refund Policy">
    <div className="prose max-w-none">
      <h2 className="text-3xl font-bold text-gray-900 mb-6">Cancellation &amp; Refund Policy</h2>
      <p className="text-gray-500 mb-6">Last updated: August 22, 2026</p>
      <section className="mb-8">
        <h3 className="text-xl font-semibold text-gray-800 mb-3">Subscriptions</h3>
        <p className="text-gray-600 mb-3">You may cancel the renewal of a monthly or annual subscription at any time. Cancellation stops the next renewal; access continues until the end of the billing period already paid for.</p>
        <p className="text-gray-600">SmushChat does not currently offer a free plan or subscription free trial. Setup and onboarding are included with paid plans.</p>
      </section>
      <section className="mb-8">
        <h3 className="text-xl font-semibold text-gray-800 mb-3">14-day refund window</h3>
        <p className="text-gray-600 mb-3">You may request a refund within 14 calendar days of the initial purchase of a subscription or lifetime plan. Refunds are returned to the original payment method after approval. Bank or payment-provider processing times may vary.</p>
        <p className="text-gray-600">Renewal payments are not automatically refundable. If a duplicate charge, billing error, or service failure occurred, contact us so we can review it fairly.</p>
      </section>
      <section className="mb-8">
        <h3 className="text-xl font-semibold text-gray-800 mb-3">Free custom demo</h3>
        <p className="text-gray-600">The custom demo is free and does not create a subscription. If you choose to deploy or continue using the chatbot after reviewing the preview, you must select a paid plan. See the <a href="/legal/free-demo-policy">Free Demo Policy</a>.</p>
      </section>
      <section className="mb-8">
        <h3 className="text-xl font-semibold text-gray-800 mb-3">How to request cancellation or refund</h3>
        <p className="text-gray-600">Email support@smushlabs.ai from the email associated with your account and include the plan and purchase date. We may request transaction details needed to locate the payment.</p>
      </section>
    </div>
  </LegalLayout>
);

export default CancellationRefund;
